import { render, staticRenderFns } from "./DSFiltredSelect.vue?vue&type=template&id=b75dd8d2&scoped=true&"
import script from "./DSFiltredSelect.vue?vue&type=script&lang=js&"
export * from "./DSFiltredSelect.vue?vue&type=script&lang=js&"
import style0 from "./DSFiltredSelect.vue?vue&type=style&index=0&id=b75dd8d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75dd8d2",
  null
  
)

export default component.exports